export class OverviewScopeModel {
	public F1004 = [
		{
			title: 'property information',
			items: [
				{
					class: 'cv-overview-data__info__address',
					path: 'CV_EXTENSION_SECTION.FIELDS.CVSubjectStreetAddress',
					label: '',
					historicalClass: 'cv-overview-data__info__btn'
				},
				{
					class: 'cv-overview-data__info__price',
					path: 'CV_EXTENSION_SECTION.FIELDS.CVPropertyAppraisedValueAmount',
					label: '',
					historicalClass: 'cv-overview-data__info__btn'
				},
				{
					class: 'cv-overview-data__info__date',
					path: 'CV_EXTENSION_SECTION.FIELDS.CVAppraisalEffectiveDate',
					label: 'appraised',				
					historicalClass: 'cv-overview-data__info__btn'
				},
				{
					class: 'cv-overview-data__info__date',
					path: 'CV_EXTENSION_SECTION.FIELDS.CVScopeAppraiserReportSignedDate',
					label: 'signed date',				
					historicalClass: 'cv-overview-data__info__btn'
				}
			]
		},
		{
			title: 'appraiser information',
			items: [
				{
					class: '',
					path: 'CV_EXTENSION_SECTION.FIELDS.CVScopeAssignmentType',
					label: 'Purpose',				
					historicalClass: 'cv-overview-data__info__btn-table'
				},
				{
					class: '',
					path: 'CV_EXTENSION_SECTION.FIELDS.CVScopeLenderClientManagementCompanyName',
					label: 'Client',
					historicalClass: 'cv-overview-data__info__btn-table'
				},
				{
					class: '',
					path: 'CV_EXTENSION_SECTION.FIELDS.CVScopeLenderClientName',
					label: 'Lender',
					historicalClass: 'cv-overview-data__info__btn-table'
				},
				{
					class: '',
					path: 'CV_EXTENSION_SECTION.FIELDS.CVScopeLenderClientAddress',
					label: 'Lender Client Address',
					historicalClass: 'cv-overview-data__info__btn-table'
				},
				{
					class: '',
					path: 'CV_EXTENSION_SECTION.FIELDS.CVScopeAppraiserName',
					label: 'Appraiser',
					historicalClass: 'cv-overview-data__info__btn-table'
				},
				{
					class: '',
					path: 'CV_EXTENSION_SECTION.FIELDS.CVScopeAppraiserLicenseExpiration',
					label: 'License',
					historicalClass: 'cv-overview-data__info__btn-table'
				},
				{
					class: '',
					path: 'CV_EXTENSION_SECTION.FIELDS.CVScopeAppraiserPhone',
					label: 'Phone',
					historicalClass: 'cv-overview-data__info__btn-table'
				},
				{
					class: '',
					path: 'CV_EXTENSION_SECTION.FIELDS.CVScopeAppraiserEmail',
					label: 'Email',
					historicalClass: 'cv-overview-data__info__btn-table'
				}
			]
		}
	];
}
